/**
 * Every line on the terms gate. Shown once per account and again only when the terms or privacy version changes.
 * British spelling; no dashes as punctuation.
 */
export const TERMS_COPY = {
  title: 'Terms and privacy',
  intro: 'Please read and agree to continue to SeedForge.',
  agreePrefix: 'I have read and agree to the',
  termsLink: 'Terms and Conditions',
  agreeJoiner: 'and the',
  privacyLink: 'Privacy Policy',
  accept: 'Accept and continue',
  saveError: 'We could not save your choice. Try again.',
} as const
